module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.response), function(product) {
    return _c('document-container', {
      key: product.ids.isin,
      attrs: {
        "logo": _vm.logo,
        "documentType": "tmc-export"
      }
    }, [_c('div', {
      attrs: {
        "slot": "raw-header"
      },
      slot: "raw-header"
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": _vm.logo,
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "header"
    }, [_c('pagetitle', {
      attrs: {
        "data": {
          title: product.enriched.displayName || product.name || product.ids.isin
        }
      }
    })], 1)]), _vm._v(" "), _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('div', {
      staticClass: "tmc-info"
    }, [_c('div', [_c('strong', [_vm._v("WKN:")]), _vm._v(" " + _vm._s(product.ids.wkn) + "   |  \n            "), _c('strong', [_vm._v("ISIN:")]), _vm._v(" " + _vm._s(product.ids.isin) + "   |  \n            "), _c('strong', [_vm._v("Stand:")]), _vm._v(" "), _c('i', [_vm._v(_vm._s(_vm.time))])]), _vm._v(" "), (product.enriched.tmc.watchlist.check.tmc.displayInfoText) ? [_c('br'), _vm._v(" "), _c('i', {
      class: ("fa " + (product.enriched.tmc.watchlist.check.tmc.conflict ? 'fa-exclamation-circle tmc-error' : 'fa-check-circle tmc-success'))
    }), _vm._v(" " + _vm._s(product.enriched.tmc.watchlist.check.tmc.info) + "\n          ")] : _vm._e()], 2), _vm._v(" "), _c('table', {
      staticClass: "table is-narrow"
    }, [_c('thead', [_c('tr', [_c('th', {
      staticStyle: {
        "width": "30%"
      }
    }, [_vm._v("Name")]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "35%"
      }
    }, [_vm._v(_vm._s(product.enriched.tmc.watchlist.check.product.label))]), _vm._v(" "), _c('th', {
      staticStyle: {
        "width": "35%"
      }
    }, [_vm._v(_vm._s(product.enriched.tmc.watchlist.check.reference.label))])])]), _vm._v(" "), _c('tbody', _vm._l((product.enriched.tmc.watchlist.check.tmc.criteria), function(row) {
      return _c('tr', {
        class: row.conflict ? 'tmc-row-conflict' : 'tmc-row-success'
      }, [_c('td', [_c('i', {
        class: ("fa " + (row.conflict ? 'fa-remove tmc-error' : 'fa-check tmc-success'))
      }), _vm._v("\n               \n              " + _vm._s(row.label) + "\n            ")]), _vm._v(" "), _c('td', [_c('i', {
        staticClass: "fa fa-plus-circle",
        class: row.positive ? 'tmc-success' : 'tmc-neutral'
      }), _vm._v(" " + _vm._s(row.positive ? row.positive.join(', ') : '—') + "\n              "), _c('br'), _vm._v(" "), _c('i', {
        staticClass: "fa fa-minus-circle",
        class: row.negative ? 'tmc-error' : 'tmc-neutral'
      }), _vm._v(" " + _vm._s(row.negative ? row.negative.join(', ') : '—') + "\n            ")]), _vm._v(" "), (_vm.$route.query.comparisonMode === 'REFERENCE_TMC_GROUP') ? _c('td', [_c('i', {
        staticClass: "fa fa-plus-circle",
        class: row.referencePositive ? 'tmc-success' : 'tmc-neutral'
      }), _vm._v(" " + _vm._s(row.referencePositive ? row.referencePositive.join(', ') : '—') + "\n              "), _c('br'), _vm._v(" "), _c('i', {
        staticClass: "fa fa-minus-circle",
        class: row.referenceNegative ? 'tmc-error' : 'tmc-neutral'
      }), _vm._v(" " + _vm._s(row.referenceNegative ? row.referenceNegative.join(', ') : '—') + "\n            ")]) : _vm._e(), _vm._v(" "), (_vm.$route.query.comparisonMode === 'REFERENCE_PROVIDER' || _vm.$route.query.comparisonMode === 'CUSTOMER') ? _c('td', [(row.referencePositive) ? [_vm._v(_vm._s(row.referencePositive.join(', ')))] : [_vm._v("—")]], 2) : _vm._e()])
    }), 0)])]), _vm._v(" "), _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('h2', [_vm._v("Nachhaltigkeit")]), _vm._v(" "), _c('table', {
      staticClass: "table is-narrow"
    }, _vm._l((_vm.esgTranslations), function(value, key) {
      return _c('tr', [_c('td', {
        staticStyle: {
          "width": "20%"
        }
      }, [_vm._v(_vm._s(value))]), _vm._v(" "), (key !== 'paiCluster') ? _c('td', [_vm._v(_vm._s(product.enriched.tmc.product.derived.sustainability[key] || '—'))]) : _vm._e(), _vm._v(" "), (key === 'paiCluster') ? _c('td', {
        domProps: {
          "innerHTML": _vm._s(_vm._.get(product.enriched.tmc.product.derived.sustainability, 'paiCluster', []).length !== 0 ? product.enriched.tmc.product.derived.sustainability.paiCluster.join('<br>') : '—')
        }
      }) : _vm._e()])
    }), 0)]), _vm._v(" "), _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_c('h2', [_vm._v("Kommentar")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm._.get(product.enriched.tmc.watchlist.check, 'comment', false) || '—'))])])])
  }), _vm._v(" "), (_vm.ignoredProducts.length > 0) ? _c('document-container', {
    key: 'ignored',
    attrs: {
      "logo": _vm.logo,
      "documentType": "tmc-export"
    }
  }, [_c('div', {
    attrs: {
      "slot": "raw-header"
    },
    slot: "raw-header"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.logo,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "header"
  }, [_c('pagetitle', {
    attrs: {
      "data": {
        title: 'Produkte ohne Zielmarktabgleich'
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "page-block",
    attrs: {
      "slot": "raw-body"
    },
    slot: "raw-body"
  }, [_c('h2', [_vm._v("Für folgende Werte konnte kein Abgleich erstellt werden:")])]), _vm._v(" "), _vm._l((_vm.ignoredProducts), function(product) {
    return _c('div', {
      staticClass: "page-block",
      attrs: {
        "slot": "raw-body"
      },
      slot: "raw-body"
    }, [_vm._v("\n        ISIN:\n        "), _c('strong', [_vm._v(_vm._s(product.isin))]), _vm._v(" | Bezeichnung:\n        "), _c('strong', [_vm._v(_vm._s(product.name))])])
  })], 2) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64e15b03"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tmc-export/TmcMultiExport.vue
// module id = 694
// module chunks = 0